import { TeamYear } from "./types";

export const team2024_25: TeamYear = {
  year: "2024-25",
  facultyAdvisors: [{
      id: "fac-1",
      name: "Dr. K.S.Tiwari",
      role: "Faculty Coordinator",
      image: "/team/common/tiwari-mam.jpg",
      deptOrBranch: "E&TC Department",
      social: { linkedin: "https://linkedin.com/in/dr-kanchan-s-tiwari-01705171"},
    },
    {
      id: "fac-2",
      name: "Prof. Yogita Ajgar",
      role: "Faculty Coordinator",
      image: "/team/common/yogita-mam.jpg",
      deptOrBranch: "E&TC Department",
      social: { linkedin: "https://linkedin.com/in/yogita-ajgar-847b1071" },
    },],
  founder: [{
      id: "founder-1",
      name: "Arnav Botre",
      role: "Founder",
      image: "/team/common/arnav.jpg",
      deptOrBranch: "Alumni - E&TC",
      social: { linkedin: "https://www.linkedin.com/in/arnav-botre-b2a7591b2/", instagram:"https://www.instagram.com/arnav_botre14/", email: "botrearnav@gmail.com" },
    },],
  coreCommittee: [
    {
      id: "core-1",
      name: "Vighnesh Khichade",
      role: "President",
      image: "/team/2024-25/vighnesh.jpg",
      deptOrBranch: "",
      social: { linkedin: "https://linkedin.com/in/vighnesh-a-p-khichade-03346a267", instagram: "https://www.instagram.com/vighnesh_apk?igsh=aWEyMmNiOHRrOXVk", email:"vighneshapkedu@gmail.com"},
    },
    {
      id: "core-2",
      name: "Shraddha Mirkhalkar",
      role: "Vice President",
      image: "/team/2024-25/shraddha.jpg",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/shraddha-mirkhalkar-018182285?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app", instagram: "https://www.instagram.com/shraddhaaa__22?igsh=aGl5OHlmZnl3bm9w", email: "mirkhalkarshraddha22@gmail.com" },
    },
   {
      id: "core-3",
      name: "Pavan Kodlinge",
      role: "Treasurer",
      image: "/team/2024-25/pavan.jpg",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/pavan-kodlinge-759673313", email:"pavankodlinge2@gmail.com"},
    },
    {
      id: "core-4",
      name: "Atharva Patil",
      role: "Documentation Head",
      image: "/team/2024-25/atharva.jpg",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/atharva-patil-853b25308?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app", instagram: "https://www.instagram.com/atharvapatil5761?igsh=Mzh2MmduODB6a2Nx", email:"patilatharva486@gmail.com" },
    },
    {
      id: "core-5",
      name: "Parth Pawar",
      role: "Publicity & Marketing Head",
      image: "/team/2024-25/parth.jpg",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/parth-pawar-48b060277?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app", instagram: "https://www.instagram.com/theparthpawar?igsh=aDd4Y3R5MW56YmRk", email: "parthx15@gmail.com" },
    },
    {
      id: "core-6",
      name: "Sweta Mirgane",
      role: "Social Media Head",
      image: "/team/2024-25/sweta.jpg",
      deptOrBranch: "",
      social: { linkedin: "www.linkedin.com/in/sweta-mirgane-212303314", instagram: "https://www.instagram.com/swetamirgane8?igsh=MTdtYWRhcGR2aGI4aA==", email: "swetamirgane@gmail.com" },
    },
    {
      id: "core-7",
      name: "Sneha Aghav",
      role: "Event Head",
      image: "/team/2024-25/sneha.jpg",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/sneha-aghav-b862b4298?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app", instagram: "https://www.instagram.com/snehaaghav3117?igsh=MTBxZDd2bXIzMmVrbg==", email:"snehaaghav28@gmail.com" },
    },
    {
      id: "core-8",
      name: "Yuvraj Dhawale",
      role: "Event Head",
      image: "/team/2024-25/yuvraj.jpg",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/yuvraj-dhawale-a66347320?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app", instagram: "https://www.instagram.com/invites/contact/?igsh=lesq4kqk60e7&utm_content=8fqqq44", email:"yuvraj.d1323@gmail.com" },
    },
    {
      id: "core-9",
      name: "Shreya Patil",
      role: "Web Developer",
      image: "/team/2024-25/shreya.jpg",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/shreya-patil-6711302a6?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app", instagram: "https://www.instagram.com/shreyap1205?igsh=YWJiNWY0N2", email:"shreyahema2005@gmail.com" },
    },
    {
      id: "core-10",
      name: "Harshad Pakhale",
      role: "Graphics Designer",
      image: "/team/2024-25/harshad.jpg",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/harshad-pakhale-221hp",instagram: "https://www.instagram.com/harshad.pakhale.01?igsh=MXM1MWhtYmFxcjBhbg==", email: "harshadpakhale2005@gmail.com" },
    },
    {
      id: "core-11",
      name: "Varad Pise",
      role: "Student Coordinator",
      image: "/team/2024-25/varad.jpg",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/varad-pise-696918282?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app", instagram: "https://www.instagram.com/varad_pise_07?igsh=OW9kNXFoOThvMWdt", email:"pisevarad7@gmail.com" },
    },
    {
      id: "core-12",
      name: "Srushti Gulave",
      role: "Student Coordinator",
      image: "/team/2024-25/srushti.jpg",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/srushti-gulave-16b8002b3?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app", instagram: "https://www.instagram.com/sru________10/", email: "srushtigulave10@gmail.com" },
    },
    
  ],
};

export {}; // ✅ This ensures it is treated as a module
